<template>
    <!-- breadCrumb -->
    <div class="bread_crumb">
        <div class="bread_crumb_inner">
            <a href="" class="home">홈</a>
            <a href="">기부후원 단체</a>
        </div>
    </div>
    <!-- //breadCrumb -->

    <main id="main">
        <DonationGroupDtlForm :donationGroupSeq = donationGroupSeq />
    </main>
</template>
<script>
import DonationGroupDtlForm from '@/components/donationGroup/DonationGroupDtlForm.vue';

export default {
    props: {
        donationGroupSeq: {
            type: String,
            required: true
        }
    },
    components: {
        DonationGroupDtlForm
    }

}
</script>
<style>

</style>